var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5H10M2 7.16671H14M5.33333 4.50004V1.83337M10.6667 4.50004V1.83337M6.26667 15.1667H9.73333C11.2268 15.1667 11.9735 15.1667 12.544 14.8761C13.0457 14.6204 13.4537 14.2124 13.7094 13.7107C14 13.1403 14 12.3935 14 10.9V7.43337C14 5.9399 14 5.19316 13.7094 4.62273C13.4537 4.12097 13.0457 3.71302 12.544 3.45736C11.9735 3.16671 11.2268 3.16671 9.73333 3.16671H6.26667C4.77319 3.16671 4.02646 3.16671 3.45603 3.45736C2.95426 3.71302 2.54631 4.12097 2.29065 4.62273C2 5.19316 2 5.9399 2 7.43337V10.9C2 12.3935 2 13.1403 2.29065 13.7107C2.54631 14.2124 2.95426 14.6204 3.45603 14.8761C4.02646 15.1667 4.77319 15.1667 6.26667 15.1667Z",
    stroke: "#77D4E1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender_icon.a8d40e0d934a65d582a03e8f7f0c8bea.svg";
export { ForwardRef as ReactComponent };